"use strict";

var _regeneratorRuntime = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _slicedToArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _asyncToGenerator = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SourceLoaderUri;
var _react = _interopRequireWildcard(require("react"));
var _RenderTTree = _interopRequireDefault(require("./RenderTTree"));
var _sourceLoaderContext = _interopRequireDefault(require("./context/sourceLoaderContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ERROR_STATE = {
  error: true,
  resolvedHTML: null
};
function loadHTMLResource(_x, _x2) {
  return _loadHTMLResource.apply(this, arguments);
}
function _loadHTMLResource() {
  _loadHTMLResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(uri, _ref) {
    var body, headers, method, response, html;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = _ref.body, headers = _ref.headers, method = _ref.method;
            _context.next = 3;
            return fetch(uri, {
              body: body,
              headers: headers,
              method: method
            });
          case 3:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 9;
              break;
            }
            _context.next = 7;
            return response.text();
          case 7:
            html = _context.sent;
            return _context.abrupt("return", {
              resolvedHTML: html,
              error: false
            });
          case 9:
            return _context.abrupt("return", ERROR_STATE);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadHTMLResource.apply(this, arguments);
}
function useUriSourceLoader(_ref2) {
  var source = _ref2.source,
    onHTMLLoaded = _ref2.onHTMLLoaded;
  var _ref3 = (0, _react.useState)({
      error: false,
      resolvedHTML: null
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    loadState = _ref4[0],
    setState = _ref4[1];
  var error = loadState.error; // Effect to reload on uri changes

  (0, _react.useEffect)(function () {
    var cancelled = false;
    if (!error) {
      setState({
        error: false,
        resolvedHTML: null
      });
      loadHTMLResource(source.uri, {
        body: source.body,
        headers: source.headers,
        method: source.method
      }).then(function (state) {
        !cancelled && setState(state);
      }).catch(function () {
        !cancelled && setState(ERROR_STATE);
      });
    }
    return function () {
      cancelled = true;
    };
  }, [error, source.uri, source.body, source.headers, source.method]);
  (0, _react.useEffect)(function () {
    loadState.resolvedHTML && (onHTMLLoaded === null || onHTMLLoaded === void 0 ? void 0 : onHTMLLoaded.call(null, loadState.resolvedHTML));
  }, [loadState.resolvedHTML, onHTMLLoaded]);
  return loadState;
}
function SourceLoaderUri(props) {
  var _ref5 = (0, _react.useContext)(_sourceLoaderContext.default),
    remoteErrorView = _ref5.remoteErrorView,
    remoteLoadingView = _ref5.remoteLoadingView;
  var _useUriSourceLoader = useUriSourceLoader(props),
    resolvedHTML = _useUriSourceLoader.resolvedHTML,
    error = _useUriSourceLoader.error;
  if (error) {
    return remoteErrorView.call(null, props.source);
  }
  if (resolvedHTML === null) {
    return remoteLoadingView.call(null, props.source);
  }
  return /*#__PURE__*/_react.default.createElement(_RenderTTree.default, {
    document: resolvedHTML,
    baseUrl: props.source.uri
  });
}